import { AlbumResponse } from '@klubovna/api-client';
import { PaginationMetadata } from '@shared';

export interface AlbumsState {
  albums: AlbumResponse[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialAlbumsState: AlbumsState = {
  albums: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

